import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-fill-left",
  "use": "icon-fill-left-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-fill-left\">\n<g id=\"icon-fill-left_Direction/fill-left\">\n<g id=\"icon-fill-left_Frame 3\">\n<path id=\"icon-fill-left_Polygon 2\" d=\"M5.46093 8.38411C5.22106 8.18421 5.22106 7.81579 5.46093 7.61589L10.1799 3.68341C10.5056 3.41202 11 3.6436 11 4.06752V8V11.9325C11 12.3564 10.5056 12.588 10.1799 12.3166L5.46093 8.38411Z\" fill=\"#282C33\" />\n</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/fill-left.svg
// module id = eMvh
// module chunks = 140